/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

var screenCode = "PRICECOMPARISONREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default function PriceComparisonReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [headCells, SetHeadCells] = useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [factoryNameArray, setFactoryNameArray] = useState([]);
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
    const classes = useStyles();
    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={useStyles.visuallyHidden}>
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [cropAvailability, setCropAvailability] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        fromDate: fromDate,
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const productAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        fromDate: '',
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            fromDate: formData.fromDate
        },
        validationSchema: productAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const groupedData = cropAvailability.reduce((acc, item) => {
        if (!acc[item.productCategoryName]) {
            acc[item.productCategoryName] = [];
        }
        acc[item.productCategoryName].push(item);
        return acc;
    }, {});

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRICECOMPARISONREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
    }

    async function SubmitForm() {
        setCropAvailability([]);
        SetHeadCells([]);
        setPage(0);

        let newRes = await services.GetPriceComparisonReportDetails((fromDate).toISOString());

        setOrder('asc');
        setOrderBy('cropForecastdate');

        var result = [];
        var resultOne = [];
        var headCellsOne = [];

        newRes.forEach(y => {
            y.details.forEach(x => {
                var market = x.marketName;

                var duplicateDate = result.find(y => y.cropID === x.cropID);
                if (duplicateDate) {
                    duplicateDate[market] = duplicateDate[market] == undefined ? 0 + x.marketSellingPrice : duplicateDate[market] + x.marketSellingPrice;
                    duplicateDate.cropID = x.cropID;
                    duplicateDate.productName = x.productName;
                    duplicateDate.volumeKG = x.volumeKG;
                    duplicateDate.buyingPrice = x.buyingPrice;
                    duplicateDate.sellingPrice = x.sellingPrice;
                    duplicateDate.competitorPrice = x.competitorPrice;
                    duplicateDate.productCategoryName = y.productCategoryName;
                } else {
                    result.push({
                        [market]: x.marketSellingPrice,
                        cropID: x.cropID,
                        productName: x.productName,
                        volumeKG: x.volumeKG,
                        buyingPrice: x.buyingPrice,
                        sellingPrice: x.sellingPrice,
                        competitorPrice: x.competitorPrice,
                        productCategoryName: y.productCategoryName,
                    });
                }
            });
        });

        newRes.forEach(y => {
            y.details.forEach(x => {
                var duplicateDate = resultOne.find(y => y.market === x.marketName);
                if (duplicateDate) {
                    duplicateDate.market = x.marketName;
                } else {
                    resultOne.push({
                        market: x.marketName,
                    });
                }
            });
        });

        resultOne.sort((a, b) => a.market > b.market ? 1 : -1);

        headCellsOne.push(
            {
                id: 'productName',
                numeric: false,
                disablePadding: false,
                label: 'SKU',
                align: "left",
                colSpan: 1,
                rowSpan: 2 
            },
            {
                id: 'volumeKG',
                numeric: true,
                disablePadding: false,
                label: 'Volume(KG)',
                align: "right",
                colSpan: 1,
                rowSpan: 2
            },
            {
                id: 'cargillsPrices',
                numeric: true,
                disablePadding: false,
                label: 'Cargills Prices',
                align: "center",
                colSpan: 2 
            },
            {
                id: 'competitorPrice',
                numeric: true,
                disablePadding: false,
                label: 'Competitor Price',
                align: "right",
                colSpan: 1,
                rowSpan: 2
            }
        );

        resultOne.forEach(x => {
            headCellsOne.push({
                id: x.market,
                numeric: true,
                disablePadding: false,
                label: x.market,
                align: "right",
                rowSpan: 2
            });
        });

        setFactoryNameArray(resultOne);
        setCropAvailability(result);
        SetHeadCells(headCellsOne);
        createDataForExcel(result);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setCropAvailability([]);
            setFromDate(new Date());
        } else {
            setFromDate(new Date());
        }
    }

    useEffect(() => {
        setPage(0); 
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [fromDate]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => { });
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(cropAvailability);
    
        var settings = {
            sheetName: 'Price Comparison Report',
            fileName: 'Price Comparison Report',
            writeOptions: {}
        };
    
        let headCellsTwo = [
            { label: 'SKU', value: 'productName' },
            { label: 'Volume(KG)', value: 'volumeKG' },
            { label: 'Cargills Buying Price', value: 'buyingPrice' },
            { label: 'Cargills Selling Price', value: 'sellingPrice' },
            { label: 'Competitor Price', value: 'competitorPrice' }
        ];
    
        // Add factory-specific columns
        factoryNameArray.forEach(x => {
            const label = x.market || ' - ';
            headCellsTwo.push({ label, value: x.market });
        });
    
        const formatValue = value => {
            if (value === 0 || value == null || value === undefined) {
                return '-';
            }
            return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
    
        // Group data by category
        const groupedData = cropAvailability.reduce((acc, item) => {
            if (!acc[item.productCategoryName]) {
                acc[item.productCategoryName] = [];
            }
            acc[item.productCategoryName].push(item);
            return acc;
        }, {});
    
        let formattedCropAvailability = [];
    
        // Build data rows
        Object.keys(groupedData).forEach(categoryName => {
            const categoryHeader = {
                productName: categoryName,
                volumeKG: '',
                buyingPrice: '',
                sellingPrice: '',
                competitorPrice: '',
            };
    
            factoryNameArray.forEach(column => {
                categoryHeader[column.market] = '';
            });
    
            formattedCropAvailability.push(categoryHeader);
    
            groupedData[categoryName].forEach(item => {
                let formattedItem = {
                    productName: item.productName,
                    volumeKG: formatValue(item.volumeKG),
                    buyingPrice: formatValue(item.buyingPrice),
                    sellingPrice: formatValue(item.sellingPrice),
                    competitorPrice: formatValue(item.competitorPrice),
                };
    
                factoryNameArray.forEach(column => {
                    const value = item[column.market];
                    formattedItem[column.market] = formatValue(value);
                });
    
                formattedCropAvailability.push(formattedItem);
            });
        });
    
        const totalValues = {
            totalVolumeKG: cropAvailability.reduce((acc, curr) => acc + (curr.volumeKG || 0), 0),
            totalBuyingPrice: cropAvailability.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0),
            totalSellingPrice: cropAvailability.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0),
            totalCompetitorPrice: cropAvailability.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0),
        };
    
        factoryNameArray.forEach(column => {
            totalValues[column.market] = cropAvailability.reduce((acc, curr) => acc + (curr[column.market] || 0), 0);
        });
    
        const totalRow = {
            productName: 'Total',
            volumeKG: formatValue(totalValues.totalVolumeKG),
            buyingPrice: formatValue(totalValues.totalBuyingPrice),
            sellingPrice: formatValue(totalValues.totalSellingPrice),
            competitorPrice: formatValue(totalValues.totalCompetitorPrice)
        };
    
        factoryNameArray.forEach(column => {
            totalRow[column.market] = formatValue(totalValues[column.market]);
        });
    
        formattedCropAvailability.push(totalRow);
    
        let dataA = [
            {
                sheet: 'Price Comparison Report',
                columns: headCellsTwo,
                content: formattedCropAvailability
            }
        ];
    
        xlsx(dataA, settings);
    }
    
    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            fromDate: new Date(fromDate).toISOString().split('T')[0]
        });
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Price Comparison Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/PriceComparisonReport"}
                        btname="Add"
                        pageName="Price Comparison Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            style: {
                                                height: "48px",
                                                width: "100%"
                                            },
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {cropAvailability.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                                <TableContainer>
                                                    <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                                                        <TableHead>
                                                            <TableRow>
                                                                {headCells.map((headCell) => (
                                                                    <TableCell
                                                                        key={headCell.id}
                                                                        align={headCell.align}
                                                                        padding={headCell.disablePadding ? 'none' : 'default'}
                                                                        colSpan={headCell.colSpan || 1}
                                                                        rowSpan={headCell.rowSpan || 1}
                                                                        style={{
                                                                            border: "1px solid black", 
                                                                            fontWeight: 'bold', 
                                                                            ...headCell.style 
                                                                        }}
                                                                    >
                                                                        {headCell.label}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                            <TableRow>
                                                                {headCells.map((headCell) =>
                                                                    headCell.id === 'cargillsPrices' ? (
                                                                        <React.Fragment key={headCell.id}>
                                                                            <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' }}>Buying Price</TableCell>
                                                                            <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' }}>Selling Price</TableCell>
                                                                        </React.Fragment>
                                                                    ) : null
                                                                )}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.keys(groupedData).map((productCategoryName, catIndex) => (
                                                                <React.Fragment key={catIndex}>
                                                                    <TableRow>
                                                                        <TableCell colSpan={factoryNameArray.length + 5} align="left" style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#FFF366' }}>
                                                                            {productCategoryName}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    {stableSort(groupedData[productCategoryName], getComparator(order, orderBy))
                                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((factory, index) => {
                                                                            const labelId = `enhanced-table-checkbox-${catIndex}-${index}`;
                                                                            
                                                                            return (
                                                                                <TableRow key={index} style={{ border: '1px solid black' }}>
                                                                                    <TableCell component="th" id={labelId} scope="row" align="left" style={{border: '1px solid black' }}>
                                                                                        {factory.productName}
                                                                                    </TableCell>
                                                                                    <TableCell component="th" id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                                        {factory.volumeKG}
                                                                                    </TableCell>
                                                                                    <TableCell component="th" id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                                        {factory.buyingPrice === undefined || factory.buyingPrice === 0 ? '-' : parseFloat(factory.buyingPrice).toFixed(2)}
                                                                                    </TableCell>
                                                                                    <TableCell component="th" id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                                        {factory.sellingPrice === undefined || factory.sellingPrice === 0 ? '-' : parseFloat(factory.sellingPrice).toFixed(2)}
                                                                                    </TableCell>
                                                                                    <TableCell component="th" id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                                        {factory.competitorPrice === undefined || factory.competitorPrice === 0 ? '-' : parseFloat(factory.competitorPrice).toFixed(2)}
                                                                                    </TableCell>
                                                                                    {factoryNameArray.map((column, colIndex) => {
                                                                                        const value = factory[column.market];
                                                                                        return (
                                                                                            <TableCell key={colIndex} id={labelId} scope="row" align="right" style={{ border: '1px solid black' }}>
                                                                                                {value === undefined || value === 0 ? '-' : parseFloat(value).toFixed(2)}
                                                                                            </TableCell>
                                                                                        );
                                                                                    })}
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                </React.Fragment>
                                                            ))}
                                                            <TableRow>
                                                                <TableCell component="th" scope="row" align="left" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    Total
                                                                </TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    {cropAvailability.reduce((acc, curr) => acc + (curr.volumeKG || 0), 0)}
                                                                </TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    {cropAvailability.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    {cropAvailability.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0).toFixed(2)}
                                                                </TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    {cropAvailability.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0).toFixed(2)}
                                                                </TableCell>
                                                                {factoryNameArray.map((column, colIndex) => (
                                                                    <TableCell key={colIndex} scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                        {cropAvailability.reduce((acc, curr) => acc + (curr[column.market] || 0), 0).toFixed(2)}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={cropAvailability.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Price Comparison Report" />}</>
                        </Form>
                    </FormikProvider>
                    {cropAvailability.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <div>&nbsp;</div>
                            <style>
                                {`
                                 @page  {
                                            size: A4 landscape; 
                                            margin: 20mm;
                                        }
                               `}
                            </style>
                            <ReactToPrint
                                documentTitle={"Price Comparison Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={cropAvailability}
                                    searchData={selectedSearchValues}
                                    factoryNameArray={factoryNameArray}
                                    headCells={headCells}
                                    EnhancedTableHead={EnhancedTableHead}
                                    order={order}
                                    orderBy={orderBy}
                                    handleRequestSort={handleRequestSort}
                                    onRequestSort={handleRequestSort}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

